import script from "./AddObject.vue?vue&type=script&setup=true&lang=js"
export * from "./AddObject.vue?vue&type=script&setup=true&lang=js"

import "./AddObject.vue?vue&type=style&index=0&id=56efc083&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56efc083"]])

export default __exports__